<template>
  <div class="home">
    <div class="head-box">
      <headPage :active="headActive"/>
    </div>
    <div class="main">
      <div class="content-view">
        <router-view @setActive="getActive"></router-view>
      </div>
    </div>
    <div class="foot-box">
      <footPage/>
    </div>
  </div>
</template>
<script>
import headPage from "@/views/masses/common/headPage";
import footPage from "@/views/masses/common/footPage";

export default {
  name: "home",
  data() {
    return {
      headActive: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    headPage,
    footPage
  },
  created() {

  },
  methods: {
    getActive(data) {
      if (data) {
        this.headActive = data.headActive
      }
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
/deep/ {
  body {
    max-width: 100%;
  }
}
.home {
  width: 100%;
  height: max-content;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .head-box {
    width: 100%;
    height: 100px;
    background: rgba(0,0,0,0.3);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .main {
    width: 100%;
    flex: 1;
  }

  .foot-box {
    width: 100%;
  }
}
</style>


